var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditorInfoIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#1D7777"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1169_1025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8638 8.47047C12.4327 8.47047 12.0781 8.33141 11.8 8.05329C11.5219 7.77516 11.3828 7.4275 11.3828 7.01032C11.3828 6.59313 11.5219 6.24547 11.8 5.96735C12.0781 5.67531 12.4327 5.5293 12.8638 5.5293C13.281 5.5293 13.6287 5.67531 13.9068 5.96735C14.1849 6.24547 14.324 6.59313 14.324 7.01032C14.324 7.4275 14.1849 7.77516 13.9068 8.05329C13.6287 8.33141 13.281 8.47047 12.8638 8.47047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.324 16.5588L14.324 11.4118C14.324 10.5996 13.6656 9.94116 12.8534 9.94116C12.0412 9.94116 11.3828 10.5996 11.3828 11.4117L11.3828 16.5588C11.3828 17.371 12.0412 18.0294 12.8534 18.0294C13.6656 18.0294 14.324 17.371 14.324 16.5588Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1169_1025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7059,
    height: 14.7059,
    fill: "white",
    transform: "translate(19.8535 5.14697) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorInfoIc);
export default __webpack_public_path__ + "static/media/editor_info_ic.1a898908f6624476d3b5e6821d4ba9ba.svg";
export { ForwardRef as ReactComponent };